import * as React from 'react';

interface Props {
    action: 'enable' | 'disable' | null;
    onConfirm: () => void;
    onCancel: () => void;
}

export const VoucherToggleConfirmModal: React.FC<Props> = ({ action, onConfirm, onCancel }) => {
    if (!action) return null;

    const isEnable = action === 'enable';

    return (
        <>
            <div
                className="position-fixed top-0 start-0 w-100 h-100"
                style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}
                onClick={onCancel}
            />
            <div
                className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                style={{ zIndex: 1061, pointerEvents: 'none' }}
            >
                <div
                    className="card shadow-lg"
                    style={{ width: '100%', maxWidth: '420px', pointerEvents: 'auto' }}
                    onClick={e => e.stopPropagation()}
                >
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h5 className="mb-0">
                            {isEnable ? 'Enable Vouchers' : 'Disable Vouchers'}
                        </h5>
                        <button type="button" className="btn-close" onClick={onCancel} aria-label="Close" />
                    </div>
                    <div className="card-body">
                        {isEnable ? (
                            <>
                                <p className="mb-2">
                                    <strong>Enable program vouchers for this reservation?</strong>
                                </p>
                                <p className="text-muted small mb-0">
                                    This will immediately generate vouchers for all eligible guests based on their programs.
                                    Vouchers will continue to be recalculated automatically when the reservation is updated.
                                </p>
                            </>
                        ) : (
                            <>
                                <p className="mb-2">
                                    <strong>Disable program vouchers for this reservation?</strong>
                                </p>
                                <p className="text-muted small mb-2">
                                    All active (unconverted) program vouchers will be removed.
                                </p>
                                <p className="text-muted small mb-0">
                                    Used and ad-hoc vouchers will not be affected. Voucher generation will stop until re-enabled.
                                </p>
                            </>
                        )}
                    </div>
                    <div className="card-footer d-flex justify-content-end gap-2">
                        <button className="btn btn-secondary btn-sm" onClick={onCancel}>
                            Cancel
                        </button>
                        <button
                            className={`btn btn-sm ${isEnable ? 'btn-success' : 'btn-danger'}`}
                            onClick={onConfirm}
                        >
                            {isEnable ? 'Enable' : 'Disable'}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
